// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-25[data-v-4b4a1772]{margin-top:100px !important}", ""]);
// Exports
module.exports = exports;
